// /en/careers — layout route (EN). Pass-through <Outlet />.
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/en/careers")({
  component: () => <Outlet />,
});
